var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row align-center ma-0"},[_c('div',{staticClass:"mb-1",class:_vm.highlight == true ? 'primary--text' : '',staticStyle:{"font-size":"14px","letter-spacing":"1.05px","color":"#808080"}},[_vm._v(_vm._s(_vm.title.toUpperCase())+":")]),_c('v-spacer'),_vm._t("actions")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }